export const headers = {
    "Access-Control-Allow-Origin": "*",
    "Strict-Transport-Security": "'max-age=31536000; includeSubDomains'",
  };

export const serverErrorMessage = 'Internal Server Error';
export const unauthorizedErrorMessage = 'Unauthorized';
export const forbiddenErrorMessage = 'Forbidden';
export const badRequestErrorMessage = 'Bad Request';
export const missingDataErrorMessage = 'Not Found';

interface Headers { [header: string]: string | number | boolean; };

export class MissingDataError extends Error {
    constructor(message: string) {
        super(message);
        this.name = 'MissingDataError';
    }
}

export class UnauthorizedError extends Error {
    constructor(message: string) {
        super(message);
        this.name = 'UnauthorizedError';
    }
}

export class BadRequestError extends Error {
    constructor(message: string) {
        super(message);
        this.name = 'BadRequestError';
        this.message = message
    }
}

export class ServerError extends Error {
    constructor(message: string) {
        super(message);
        this.name = 'ServerError';
    }
}

export interface SuccessReturnBody {
    statusCode: 200,
    headers: Headers,
    body: string,
}

export interface AcceptedReturnBody {
    statusCode: 202,
    headers: Headers,
    body: string,
}

export interface CreationSuccessReturnBody {
    statusCode: 201,
    headers: Headers,
    body: string,
}

export interface MissingDataReturnBody {
    statusCode: 404,
    headers: Headers,
    body: string,
}

export interface ForbiddenReturnBody {
    statusCode: 403,
    headers: Headers,
    body: string,
}

export interface UnauthorizedReturnBody {
    statusCode: 401,
    headers: Headers,
    body: string,
}

export interface BadRequestReturnBody {
    statusCode: 400,
    headers: Headers,
    body: string,
}

export interface ServerErrorReturnBody {
    statusCode: 500,
    headers: Headers,
    body: string,
}

export function getSuccessReturnBody<T>(body: T): SuccessReturnBody {
    return {
        statusCode: 200,
        headers,
        body: JSON.stringify(body)
    }
}

export function getCreationSuccessReturnBody(createdItemTag: string): CreationSuccessReturnBody {
    return {
        statusCode: 201,
        headers,
        body: createdItemTag
    }
}

export function getAcceptedReturnBody<T>(body: T, location: string): AcceptedReturnBody {
    return {
        statusCode: 202,
        headers: {
            ...headers,
            Location: location
        },
        body: JSON.stringify(body)
    }
}

export function getUnauthorizedReturnBody(): UnauthorizedReturnBody {
    return {
        statusCode: 401,
        headers,
        body: unauthorizedErrorMessage
    }
}

export function getForbiddenReturnBody(): ForbiddenReturnBody {
    return {
        statusCode: 403,
        headers,
        body: forbiddenErrorMessage
    }
}

export function getMissingDataReturnBody(errorMessage: string): MissingDataReturnBody {
    return {
        statusCode: 404,
        headers,
        body: errorMessage
    }
}

export function getBadRequestReturnBody(errorMessage: string): BadRequestReturnBody{
    return {
        statusCode: 400,
        headers,
        body: errorMessage
    }
}

export function getServerErrorReturnBody(): ServerErrorReturnBody {
    return {
        statusCode: 500,
        headers,
        body: serverErrorMessage
    }
}
